import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
//const API_URL = 'http://localhost:7090/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  API_URL: string = environment.API_URL;


  constructor(private http: HttpClient) { }

  getCurrentUserFromServer(): Observable<any> {
    return this.http.get(`${this.API_URL}/user/getCurrent`);
  }

  getCurrentUserRepresented(): Observable<any> {
    return this.http.get(`${this.API_URL}/user/getRepresented`);
  }
  unsubscribeCurrentUser(token : TokenStorageService):Observable<any> {
    return this.http.post(`${this.API_URL}/user/borrar/${token.getId()}`,{},{ 
        headers: {
        "accessToken": token.getToken()
       }
      }
    );
  }

  generarCodigoSeguridad(token : TokenStorageService, tipo: string):Observable<any> {
    let id = token.getId();
    return this.http.get<any>(`${this.API_URL}/user/generarCodigoSeguridad/${id}/${tipo}`, )
  }
  validarCodigoSeguridad(token : TokenStorageService, codigoseguridad: string): Observable<any> {
    let id = token.getId();
    return this.http.post(`${this.API_URL}/user/validarCodigoSeguridad/${id}`,{'codigoseguridad': codigoseguridad},{ 
        headers: {
        "accessToken": token.getToken()
      }
    });
  }

  updateTokenExpiration(){
    return this.http.get(`${this.API_URL}/user/updateExpiration`);
  }

}
